module.exports = "/assets/data/7a445f8ea880ac578875eaaceb19179f-IP23.data.json";